import { Box, BoxProps, useCardStyles } from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface CardSectionProps extends OmitChakraProps<BoxProps> {
  className?: string;
}

export const CardSection = ({ as = 'section', ...props }: CardSectionProps) => {
  const styles = useCardStyles();

  return <Box as={as} __css={styles.section} {...props} />;
};
